module.exports = __webpack_public_path__ + "img/9.8648d7d2.png";